<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
         کاربران غیرفعال
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text >
        <v-row>
          <v-col cols="12"
                 sm="3"
                 md="3"

          >
            <v-autocomplete
                :items="userTypeItems"
                v-model="type"
                placeholder="نوع کاربر"
                dense
                outlined
                auto-select-first  append-icon="mdi-menu-down"

            />


          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                clearable
                @click:clear="fillDataItems"
                outlined
                dense
                placeholder="نام واحد یا شماره موبایل"
                v-model="searchvalue"
            />
            <v-btn  fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="8" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>
        <b-table
            v-if="can('userList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(actions)="row">
            <v-btn depressed class="mr-1" v-if="can('deleteUser')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
          <template #cell(active)="row" >

              <v-switch dense class="mt-0 pt-0" :label="row.item.active?'فعال':'غیرفعال'"  v-model="row.item.active" @change="changeStatus(row.item)"/>


          </template>

        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import User_se from "../user/User_se";
import {mapMutations} from "vuex";

export default {
  name: 'InactiveUser',

  data() {
    return {
      modelId: '',
      type: '',
      searchvalue: '',
      userTypeItems: [],
      model: {},
      data: [],
      showDialog: false,
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'personName', label: 'نام ', sortable: true, sortDirection: 'desc'},
        {key: 'mobile', label: 'شماره موبایل', sortable: true, sortDirection: 'desc'},
        {key: 'active', label: 'وضعیت کاربر', sortable: true, sortDirection: 'desc'},
      ],

    };

  },

  mounted() {
    this.$root.$on('InactiveUser', () => {
      this.fillDataItems()
    })

  },

  methods: {

    close(){
      this.searchvalue=""
      this.$root.$emit('InactiveUser')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              User_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
   changeStatus(model){
   User_se.changeStatus(model).then(()=>{
     this.fillDataItems()
   })
     },
    fillDataItems() {
      User_se.getPageInactive(this.skip - 1, this.take,this.type,this.searchvalue).then(response => {
        this.modelAtributes = response.data
        this.paging = response.data.page
        this.dataItems = response.data.userList
        this.userTypeItems = response.data.userTypeItems

      });
    },


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
